import AgreementSignModal from '@/components/config_components/AgreementSignModal/AgreementSignModal.vue';
/* eslint-disable arrow-body-style */
import {
  build_case_form_sections,
  hydrate_case_detail
} from '@/services/onboarding_journey_service';
import {
  tablePaginationComputed,
  tablePaginationMethods,
  tablePaginationState
} from '@/services/table_pagination_service';
import {
  hide_onboarding_system_loader_after_render,
  show_onboarding_system_loader
} from '@/views/onboarding_system_views/onboarding_ui_helpers';

const DEFAULT_FORM_SECTION_TABS = [
  { id: 'summary', label: 'Required Action: Training Review', icon: 'bi-grid', badge: 'Current' }
];

const DEMO_FORM_SECTIONS = [
  {
    id: 'employee-onboarding-form',
    form_name: 'Employee onboarding form',
    section_count: 5,
    answered_count: 17,
    sections: [
      {
        id: 'personal-information',
        label: 'Personal Information',
        sub_sections: [
          {
            id: 'personal-information-details',
            label: 'Personal Information',
            questions: [
              { id: 'first-name', label: 'First name', answer: 'Mbalenhle', is_mandatory: true },
              { id: 'last-name', label: 'Last name', answer: 'Mabaso', is_mandatory: true },
              { id: 'id-number', label: 'ID number', answer: 'Provided during onboarding', is_mandatory: true }
            ]
          }
        ]
      },
      {
        id: 'employment-information',
        label: 'Employment Information',
        sub_sections: [
          {
            id: 'employment-information-details',
            label: 'Employment Information',
            questions: [
              { id: 'job-title', label: 'Job title', answer: 'Junior Analyst', is_mandatory: true },
              { id: 'employment-type', label: 'Employment type', answer: 'Permanent', is_mandatory: true },
              { id: 'department', label: 'Department', answer: 'Finance', is_mandatory: false }
            ]
          }
        ]
      },
      {
        id: 'residential-information',
        label: 'Residential Information',
        sub_sections: [
          {
            id: 'residential-information-details',
            label: 'Residential Information',
            questions: [
              { id: 'residential-address', label: 'Residential address', answer: 'Captured during onboarding', is_mandatory: true },
              { id: 'city', label: 'City', answer: 'Johannesburg', is_mandatory: true }
            ]
          }
        ]
      },
      {
        id: 'emergency-contact',
        label: 'Emergency Contact',
        sub_sections: [
          {
            id: 'emergency-contact-details',
            label: 'Emergency Contact',
            questions: [
              { id: 'emergency-name', label: 'Contact name', answer: 'Available on submitted form', is_mandatory: true },
              { id: 'emergency-phone', label: 'Contact number', answer: 'Available on submitted form', is_mandatory: true }
            ]
          }
        ]
      },
      {
        id: 'banking-information',
        label: 'Banking Information',
        sub_sections: [
          {
            id: 'banking-information-details',
            label: 'Banking Information',
            questions: [
              { id: 'bank-name', label: 'Bank name', answer: 'Submitted', is_mandatory: true },
              { id: 'account-type', label: 'Account type', answer: 'Submitted', is_mandatory: true }
            ]
          }
        ]
      }
    ]
  }
];

function normalize_tab_label(tab = {}) {
  return String(`${tab?.id || ''} ${tab?.label || ''}`).trim().toLowerCase();
}

function tab_matches_profile(tab = {}) {
  const label = normalize_tab_label(tab);
  return ['profile', 'personal', 'applicant'].some((word) => label.includes(word));
}

function pick_reference_tab(tabs = []) {
  return tabs.find(tab_matches_profile) || tabs[0] || null;
}

const TRAINING_STATE = {
    active_filter: 'all',
    selected_training: null,
    active_detail_tab: 'summary',
    is_detail_fullscreen: false,
    sign_modal: {
      visible: false,
      agreement_title: 'Employee agreement',
      signatory_name: '',
      document_id: 'DOC-TRAINING-2026'
    },
    filters: [
      { label: 'All', count: '4', tone: 'all' },
      { label: 'Open', tone: 'open' },
      { label: 'Mine', tone: 'mine' },
      { label: 'Blocked', tone: 'blocked' }
    ],
    detail_tabs: DEFAULT_FORM_SECTION_TABS,
    case_form_sections: DEMO_FORM_SECTIONS,
    stage_timeline: [
      { title: 'Offer accepted', detail: 'Signed contract · 8 May', status: 'done', icon: 'bi-check-lg' },
      { title: 'ID & address', detail: 'Home Affairs verified', status: 'done', icon: 'bi-check-lg' },
      { title: 'Policies', detail: 'POPIA + AUP acknowledged', status: 'done', icon: 'bi-check-lg' },
      { title: 'Training', detail: 'Cybersecurity 0/3', status: 'current', icon: 'bi-exclamation-lg' },
      { title: 'Assets', detail: 'Laptop & badge ready', status: 'locked', icon: 'bi-lock' }
    ],
    questionnaire_answers: [
      {
        question: 'Core eligibility confirmed?',
        answer: 'Yes',
        tone: 'success'
      },
      {
        question: 'Outstanding items?',
        answer: 'Training missing',
        tone: 'warning'
      }
    ],
    training_items: [
      {
        training: 'Cybersecurity essentials',
        case_name: 'Sarah Khumalo',
        modules: '0 / 3',
        status: 'Missing',
        status_tone: 'danger',
        impact: 'Blocks access',
        due: '17 May'
      },
      {
        training: 'POPIA refresher',
        case_name: 'All staff (218)',
        modules: '166 / 218',
        status: 'In progress',
        status_tone: 'warning',
        impact: 'Annual gate',
        due: '17 May'
      },
      {
        training: 'Product sales 101',
        case_name: 'NewGX Capital team',
        modules: '6 / 6',
        status: 'Complete',
        status_tone: 'success',
        impact: 'Activation gate',
        due: 'Done'
      },
      {
        training: 'Anti-bribery',
        case_name: 'ABC Tech directors',
        modules: '1 / 3',
        status: 'In progress',
        status_tone: 'warning',
        impact: 'Activation gate',
        due: '20 May'
      }
    ]

};

export default {
  name: 'OnboardingManageTraining',
  components: {
    AgreementSignModal
  },
  data: () => ({
    ...TRAINING_STATE,
    sign_modal: { ...TRAINING_STATE.sign_modal },
    ...tablePaginationState()
  }),
  computed: {
    table_total_rows() {
      return this.filtered_training_items.length;
    },
    filtered_training_items() {
      return this.filter_table_rows(this.training_items);
    },
    paginated_training_items() {
      return this.paginate_table_rows(this.filtered_training_items);
    },
    ...tablePaginationComputed,
    active_form_section() {
      const forms = Array.isArray(this.case_form_sections) ? this.case_form_sections : [];
      for (const form of forms) {
        const matched_section = (Array.isArray(form?.sections) ? form.sections : [])
          .find((section) => this.tab_id_for_section(form, section) === this.active_detail_tab);

        if (matched_section) {
          return matched_section;
        }
      }

      return null;
    }
  },
  methods: {
    tab_id_for_section(form, section) {
      return `form-${form?.id || 'section'}-${section?.id || section?.label || 'item'}`;
    },
    build_detail_tabs(form_sections = []) {
      const section_tabs = [];
      form_sections.forEach((form) => {
        (Array.isArray(form?.sections) ? form.sections : []).forEach((section) => {
          section_tabs.push({
            id: this.tab_id_for_section(form, section),
            label: section?.label || form?.form_name || 'Section',
            icon: this.tab_icon_for_section(form, section)
          });
        });
      });
      const reference_tab = pick_reference_tab(section_tabs);
      const tabs = [{
        id: 'summary',
        label: 'Required Action: Training Review',
        icon: 'bi-grid',
        badge: 'Current'
      }];
      if (reference_tab) {
        tabs.push({
          ...reference_tab,
          label: 'Application Reference',
          badge: 'Reference'
        });
      }
      section_tabs
        .filter((tab) => tab.id !== reference_tab?.id)
        .forEach((tab) => {
          tabs.push(tab);
        });
      return tabs;
    },
    tab_icon_for_section(form = {}, section = {}) {
      const label = String(`${form?.form_name || ''} ${section?.label || ''}`).trim().toLowerCase();
      return ['document', 'upload', 'attachment', 'file', 'evidence'].some((word) => label.includes(word))
        ? 'bi-folder'
        : 'bi-list-check';
    },
    normalize_case_form_sections(form_sections = []) {
      return form_sections.length ? form_sections : DEMO_FORM_SECTIONS;
    },
    set_active_filter(tone) {
      this.active_filter = tone;
      this.reset_table_page();
    },
    ...tablePaginationMethods,
    async open_training_detail(training_item) {
      show_onboarding_system_loader('Loading training drawer...');
      this.selected_training = training_item;
      this.active_detail_tab = 'summary';
      this.is_detail_fullscreen = false;
      const default_sections = this.normalize_case_form_sections(training_item?.form_sections || []);
      this.case_form_sections = default_sections;
      this.detail_tabs = this.build_detail_tabs(default_sections);

      if (!training_item?.case_item) {
        hide_onboarding_system_loader_after_render(this);
        return;
      }

      const hydrated_case = await hydrate_case_detail(training_item.case_item).catch(() => null);
      if (!hydrated_case) {
        hide_onboarding_system_loader_after_render(this);
        return;
      }

      this.case_form_sections = this.normalize_case_form_sections(build_case_form_sections(hydrated_case));
      this.detail_tabs = this.build_detail_tabs(this.case_form_sections);
      hide_onboarding_system_loader_after_render(this);
    },
    close_training_detail() {
      this.selected_training = null;
      this.is_detail_fullscreen = false;
      this.active_detail_tab = 'summary';
      this.case_form_sections = DEMO_FORM_SECTIONS;
      this.detail_tabs = DEFAULT_FORM_SECTION_TABS;
    },
    set_detail_tab(tab_id) {
      this.active_detail_tab = tab_id;
    },
    current_detail_action_tab() {
      return this.detail_tabs.find((tab) => String(tab?.badge || '').trim().toLowerCase() === 'current') || this.detail_tabs[0] || null;
    },
    current_detail_action_copy() {
      return 'Review outstanding training requirements, confirm blockers are cleared, and decide whether the case can move forward.';
    },
    open_selected_training_profile() {
      const profile_tab = this.detail_tabs.find(tab_matches_profile);
      this.active_detail_tab = profile_tab?.id || 'summary';
    },
    toggle_detail_fullscreen() {
      this.is_detail_fullscreen = !this.is_detail_fullscreen;
    },
    open_sign_modal(agreement_title = 'Employee agreement', signatory_name = '') {
      this.sign_modal = {
        visible: true,
        agreement_title,
        signatory_name: signatory_name || 'Sarah Khumalo',
        document_id: 'DOC-TRAINING-2026'
      };
    },
    close_sign_modal() {
      this.sign_modal.visible = false;
    },
    complete_signature() {
      this.close_sign_modal();
    },
    status_badge_class(tone) {
      if (tone === 'danger') {
        return 'bg-danger-subtle text-danger-emphasis';
      }

      if (tone === 'success') {
        return 'bg-success-subtle text-success-emphasis';
      }

      if (tone === 'warning') {
        return 'bg-warning-subtle text-warning-emphasis';
      }

      return 'bg-secondary-subtle text-secondary-emphasis';
    },
    progress_bar_color() {
      return '#16865f';
    },
    answer_dot_class(tone) {
      if (tone === 'success') {
        return 'bg-success';
      }

      if (tone === 'warning') {
        return 'bg-warning';
      }

      return 'bg-secondary';
    }
  }
};
